// Utils.js
import { PlusOutlined } from '@ant-design/icons';

export const convertStrToList = (str) => {
    let strList = str.split(',')
    return strList;
};

export const convertStrToNumberList = (str) => {
    let strList = str.split(',')
    let res = [];
    strList.map( item => {
        res.push(Number(item));
    })
    return res;
};

export const convertListToStr = (strList) => {
    return strList.toString();
};

export const formatDate = (timestamp) => {
    if (timestamp === 0) {
        return ''
    }
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    };
    const milliseconds = timestamp > 10000000000 ? timestamp : timestamp * 1000;
    
    return new Intl.DateTimeFormat('zh-CN', options).format(new Date(milliseconds));
  };

// 后端返回的图片地址可能是 http，而 App 页面跑在 https 下，
// 会被 WebView 当作混合内容拦截，这里统一升级为 https
export const toHttpsUrl = (url) => {
  if (typeof url !== 'string') {
    return url;
  }
  return url.trim().replace(/^http:\/\//i, 'https://');
};

// 把页面（外层滚动条）滚回最顶部，用于翻页后定位
export const scrollPageToTop = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.scrollTo(0, 0);
};

export const getTimeStamp = (formatTime) => {
  if (formatTime === '') {
    return 0
  }
  const dateObject = new Date(formatTime);

  const timestamp = dateObject.getTime();
  return timestamp
}
  

export const getStatusText = (status) => {
    let statusText = '审核中';
    if (status === 0) {
        statusText = '已下线'
    } else if (status === 1) {
        statusText = '已上线'
    } else if (status === 2) {
        statusText = '审核中'
    }
    
    statusText = statusText + '（'+status + '）';
    return statusText
}

export const getAuditStatusText=(status) => {
    let statusText = '未审核';
    if (status === 0) {
        statusText = '未审核'
    } else if (status === 1) {
        statusText = '机审通过'
    } else if (status === 2) {
        statusText = '安全部人审通过'
    } else if (status === 3) {
        statusText = '后台人审通过'
    } else if (status === -1) {
        statusText = '机审驳回'
    } else if (status === -2) {
        statusText = '安全部人审驳回'
    } else if (status === -3) {
        statusText = '后台人审驳回'
    } else if (status === -4) {
        statusText = '后台删除'
    } else if (status === -5) {
        statusText = '用户删除'
    }

    statusText = statusText + '（'+status + '）';
    return statusText
}

export const getNoticeStatusText = (status) => {
    let statusText = '未生效';
    if (status === 0) {
        statusText = '未生效'
    } else if (status === 1) {
        statusText = '生效中'
    }
    
    statusText = statusText + '（'+status + '）';
    return statusText
}

export const getUserGenderText = (status) => {
  let statusText = '未知';
  if (status === 0) {
      statusText = '未知'
  } else if (status === 1) {
      statusText = '男'
  } else if (status === 2) {
      statusText = '女'
  }
  
  statusText = statusText + '（'+status + '）';
  return statusText
}


export const getUserBanStatusText = (status) => {
  let statusText = '未封禁';
  if (status === 0) {
    statusText = '未封禁'
  } else if (status === 1) {
    statusText = '已封禁'
  }
  
  statusText = statusText + '（'+status + '）';
  return statusText
}

export const getUserTypeText = (status) => {
  let statusText = '普通用户';
  if (status === 0) {
      statusText = '普通用户'
  } else if (status === 1) {
    statusText = '后台虚拟用户'
  }
  
  statusText = statusText + '（'+status + '）';
  return statusText
}

export const getActivityEnrollText = (status) => {
    let statusText = '未定义';
    if (status === 0) {
        statusText = '未定义'
    } else if (status === 1) {
        statusText = '审核中'
    } else if (status === 2) {
        statusText = '已通过'
    } else if (status === 3) {
        statusText = '已拒绝'
    }else if (status === 4) {
        statusText = '创建者'
    }else if (status === 5) {
        statusText = '已取消'
    }else if (status === 6) {
        statusText = '活动取消'
    }
    
    statusText = statusText + '（'+status + '）';
    return statusText
}

export const getClubMemberStatusText = (status) => {
    let statusText = '未定义';
    if (status === 0) {
        statusText = '未定义'
    } else if (status === 1) {
        statusText = '已通过'
    } else if (status === 2) {
        statusText = '审核中'
    } else if (status === 3) {
        statusText = '已拒绝'
    }else if (status === 4) {
        statusText = '创建者'
    }else if (status === 5) {
        statusText = '已退出'
    }else if (status === 6) {
        statusText = '被邀请'
    }else if (status === 7) {
        statusText = '社团取消'
    }

    statusText = statusText + '（'+status + '）';
    return statusText
}

export const validatePhoneNumber = (phoneNumber) => {
  // 使用正则表达式匹配中国大陆手机号格式
  const chinesePhoneRegex = /^1[3456789]\d{9}$/;

  // 检查手机号码是否匹配正则表达式
  if (chinesePhoneRegex.test(phoneNumber)) {
    // 格式正确
    return true;
  } else {
    // 格式不正确
    return false;
  }
}

export const getGenderByText = (genderText) => {
    let user_gender = 0;
    if (genderText === 'no_gender') {
      user_gender = 0;
    } else if (genderText === 'male') {
      user_gender = 1;
    } else if (genderText === 'female') {
      user_gender = 2;
    } 

    return user_gender;
}

export const getGenderValue = ( gender ) => {
    if (gender === 0) {
      return "no_gender"
    } else if (gender === 1) {
      return "male"
    } else if (gender === 2) {
      return "female"
    }
}

export const getBannerJumpTypeText = (jump_url, jump_type) => {
  if (jump_url.trim() === '') {
    return ""
  }

  if (jump_type === 0) {
    return "网页"
  } else if ( jump_type === 1) {
    return "图片"
  }
  return ""
}

export const uploadButton = (
  <div>
    <PlusOutlined />
    <div
      style={{
        marginTop: 8,
      }}
    >
      Upload
    </div>
  </div>
);
